import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Col, UiImage, UiQuestionnaireLayout, UiText} from '~/components/elements';
import {BIRTH_CONTROL_REQUEST_KEYS} from '~/constants/medical-questionnaires';
import {useNotification} from '~/hooks';
import {setBackQuestionnaire} from '~/redux/questionnaires/slice';
import {RootState} from '~/redux/root-reducer';
import {AppDispatch} from '~/redux/root-store';
import {spacing} from '~/utils/theme/spacing';

const Questionnaire3Screen = () => {
  const dispatch: AppDispatch = useDispatch();
  const {addMessage} = useNotification(dispatch);
  const medicalQuestionnaire = useSelector((state: RootState) => state.questionnaires.medicalQuestionnaire);

  const questionnaires = medicalQuestionnaire?.questionnaires;
  const questionnaire = questionnaires?.find(i => i.key === BIRTH_CONTROL_REQUEST_KEYS.INVALID);

  return (
    <UiQuestionnaireLayout actions={questionnaire?.actions}>
      <Col alignItems="center" textAlign="center">
        <UiImage type="icon" name={questionnaire?.icon} boxSize={spacing.ultra} mt={spacing.medium} />
        <UiText fontSize="2xl" fontWeight="bold" mt={spacing.xmedium}>
          {questionnaire?.questions?.default}
        </UiText>
        <UiText fontSize="sm" mt={spacing.xmedium} px={spacing.small}>
          {questionnaire?.descriptions?.default}
        </UiText>
        <UiText fontSize="sm" mt={spacing.small} px={spacing.small}>
          {questionnaire?.descriptions?.sub}
        </UiText>
      </Col>
    </UiQuestionnaireLayout>
  );
};

export default Questionnaire3Screen;
